import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {Helmet} from "react-helmet"
import BudgetsTableHeader from "./budgets-table-header";
import BudgetsTableRow from "./budgets-table-row";
import * as api from "../../api";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import {NoFilter} from "../../components/table/filters/no-filter";

function mapStateToProps(state) {
    return {};
}

class Budgets extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getBudgetsList, [this.props.customerId]),
        }
    }

    render() {
        return (
            <div className="main-container">
                <Helmet>
                    <title>Insite | Budgets</title>
                </Helmet>
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Budgets</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="budgets"
                                                     canExport={true} filterComponent={NoFilter}
                                                     headerComponent={BudgetsTableHeader}
                                                     rowComponent={BudgetsTableRow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(Budgets);